import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedSocieteComposantFamilleApiService } from './societe-composant-famille-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteComposantFamilleApiService extends GeneratedSocieteComposantFamilleApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
